/* eslint-disable max-len */
const React = require('react');
const { Black, Default, White, BlueMP, BlueML, Gray, Yellow } = require('./Images/Colors');
const { MCO, MLA, MLB, MLC, MLM, MLU, MPE } = require('./Images/Countries');
const { getYellowBrandPublicKeyList, getBlueBrandPublicKeyList } = require('./utils');

function componentProps(i18n, lang, brand) {
  const showBrandYellowBrandFields = getYellowBrandPublicKeyList(brand);
  const showBrandBlueBrandFields = getBlueBrandPublicKeyList(brand);

  return {
    title: i18n.gettext('Wallet Brick'),
    description: i18n.gettext('Construye y comprueba la experiencia visual en tiempo real. Cuando esté todo listo, descarga o copia el código generado para agregarlo a tu sitio web o compartirlo con un desarrollador.'),
    breadCrumbLevels: [
      {
        text: i18n.gettext('Documentación'),
        id: '1',
        href: `/developers/${lang}/docs`,
      },
      {
        text: i18n.gettext('Checkout Bricks'),
        id: '2',
        href: `/developers/${lang}/docs/checkout-bricks/landing`,
      },
      {
        text: i18n.gettext('Wallet Brick'),
        id: '3',
        href: `/developers/${lang}/docs/checkout-bricks/wallet-brick/introduction`,
      },
      {
        text: i18n.gettext('Demostración'),
        id: '4',
        disabled: true,
      },
    ],
    publicKey: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d',
    optionsDescription: i18n.gettext('Configuraciones generales'),
    mobileDescription: i18n.gettext('Ingresa a la Demostración en una computadora para hacer configuraciones más avanzadas y tener acceso al código generado.'),
    languages: [
      {
        description: i18n.gettext('Português'),
        value: 'pt',
      },
      {
        description: i18n.gettext('Español'),
        value: 'es',
      },
      {
        description: i18n.gettext('English'),
        value: 'en',
      },
    ],
    options: [

      // --------------------------------------------------------
      {
        id: 'publicKey',
        type: 'dropdown',
        label: i18n.gettext('País de operación'),
        placeholder: i18n.gettext('País de operación'),
        trackingLabel: 'COUNTRY_OF_OPERATION',
        items: [
          { value: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', primary: i18n.gettext('Argentina'), icon: <MLA />, siteId: 'MLA' },
          { value: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', primary: i18n.gettext('Brasil'), icon: <MLB />, siteId: 'MLB' },
          { value: 'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', primary: i18n.gettext('México'), icon: <MLM />, siteId: 'MLM' },
          { value: 'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', primary: i18n.gettext('Uruguay'), icon: <MLU />, siteId: 'MLU' },
          { value: 'TEST-af696d89-c335-4cc1-982c-af28f38e7894', primary: i18n.gettext('Colombia'), icon: <MCO />, siteId: 'MCO' },
          { value: 'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', primary: i18n.gettext('Chile'), icon: <MLC />, siteId: 'MLC' },
          { value: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', primary: i18n.gettext('Perú'), icon: <MPE />, siteId: 'MPE' },
        ],
        width: 'full',
      },
      {
        id: 'theme',
        type: 'dropdown',
        label: i18n.gettext('Tema del botón'),
        placeholder: i18n.gettext('Tema del botón'),
        trackingLabel: 'THEME',
        defaultValue: 'default',
        items: [
          { value: 'default', primary: i18n.gettext('Default'), icon: <Yellow /> },
          { value: 'dark', primary: i18n.gettext('Dark'), icon: <Black /> },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandYellowBrandFields,
          },
        ],
      },
      {
        id: 'buttonBackground',
        type: 'dropdown',
        label: i18n.gettext('Background del botón'),
        placeholder: i18n.gettext('Background del botón'),
        trackingLabel: 'BUTTON_BACKGROUND',
        defaultValue: 'default',
        items: [
          { value: 'default', primary: i18n.gettext('Default'), icon: <Default /> },
          { value: 'black', primary: i18n.gettext('Black'), icon: <Black /> },
          { value: 'blue', primary: 'Blue', icon: <BlueMP /> },
          { value: 'white', primary: i18n.gettext('White'), icon: <White /> },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandBlueBrandFields,
          },
        ],
      },
      {
        id: 'action',
        type: 'dropdown',
        label: i18n.gettext('Acción del botón'),
        placeholder: i18n.gettext('Acción del botón'),
        trackingLabel: 'ACTION',
        defaultValue: 'pay',
        items: [
          { value: 'pay', primary: i18n.gettext('Pagar con Mercado Pago') },
          { value: 'buy', primary: i18n.gettext('Comprar con Mercado Pago') },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandBlueBrandFields,
          },
        ],
      },

      // --------------------------------------------------------
      {
        id: 'buttonStyleTitle',
        type: 'title',
        title: i18n.gettext('Configuraciones de value prop'),
        label: i18n.gettext('Muéstrales a quienes compran en tu tienda las ventajas de pagar con Mercado Pago.'),
        width: 'full',
      },
      {
        id: 'showValueProp',
        type: 'switch',
        trackingLabel: 'SHOW_VALUE_PROP',
        label: i18n.gettext('Mostrar value prop'),
        width: 'full',
        defaultValue: true,
        checked: true,
      },
      {
        id: 'valueProp',
        type: 'dropdown',
        label: i18n.gettext('Value prop a mostrar'),
        placeholder: i18n.gettext('Value prop a mostrar'),
        trackingLabel: 'VALUE_PROP',
        defaultValue: 'security_safety',
        items: [
          { value: 'security_safety', primary: i18n.gettext('Paga de manera segura') },
          { value: 'security_details', primary: i18n.gettext('Protección para tus datos') },
          { value: 'convenience_all', primary: i18n.gettext('Pago en cuotas con o sin tarjeta') },
          { value: 'practicality', primary: i18n.gettext('Usa tarjetas guardadas o tu dinero disponible') },
          { value: 'convenience_credits', primary: i18n.gettext('Hasta 12 cuotas sin tarjeta') },
          { value: 'smart_option', primary: i18n.gettext('Smart') },
        ],
        width: 'full',
      },
      {
        id: 'smartMessage',
        type: 'message',
        children: i18n.gettext('En la opción “Smart”, analizamos las compras realizadas en tu tienda para definir la mejor value prop.'),
        messageType: 'info',
        hierarchy: 'quiet',
        width: 'full',
        conditionalRender: [
          {
            inputId: 'valueProp',
            expectedValue: ['smart_option'],
          },
        ],
      },
      {
        id: 'onboardingCreditsMessage',
        type: 'message',
        children: i18n.jsx.gettext('El mensaje se mostrará cuando se cree la {0}preferencia{1} con el atributo de purpose igual a {0}onboarding_credits{1}.', { tags: { 0: '<b>', 1: '</b>' } }),
        messageType: 'warning',
        hierarchy: 'quiet',
        width: 'full',
      },
      {
        id: 'convenienceAllonboardingCreditsMessage',
        type: 'message',
        children: i18n.gettext('Opción solo disponible para Argentina, Brasil y México.'),
        messageType: 'warning',
        hierarchy: 'quiet',
        width: 'full',
      },
      {
        id: 'valuePropColorBlueBrand',
        type: 'dropdown',
        label: i18n.gettext('Color de value prop'),
        placeholder: i18n.gettext('Color de value prop'),
        trackingLabel: 'VALUE_PROP_COLOR',
        defaultValue: 'grey',
        items: [
          { value: 'grey', primary: 'Grey', icon: <Gray /> },
          { value: 'white', primary: i18n.gettext('White'), icon: <White /> },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandBlueBrandFields,
          },
        ],
      },
      {
        id: 'valuePropColorYellowBrand',
        type: 'dropdown',
        label: i18n.gettext('Color de la value prop'),
        placeholder: i18n.gettext('Color de la value prop'),
        trackingLabel: 'VALUE_PROP_COLOR',
        defaultValue: 'blue',
        items: [
          { value: 'blue', primary: 'Blue', icon: <BlueML /> },
          { value: 'white', primary: i18n.gettext('White'), icon: <White /> },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandYellowBrandFields,
          },
          {
            inputId: 'theme',
            expectedValue: ['default'],
          },
        ],
      },
      {
        id: 'valuePropColorMessageBlue',
        type: 'message',
        children: i18n.gettext('Recomendamos usar el color “Blue” si el fondo de tu tienda es claro.'),
        messageType: 'info',
        hierarchy: 'quiet',
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandYellowBrandFields,
          },
          {
            inputId: 'theme',
            expectedValue: ['default'],
          },
          {
            inputId: 'valuePropColorYellowBrand',
            expectedValue: ['blue'],
          },
        ],
      },
      {
        id: 'valuePropColorMessageWhite',
        type: 'message',
        children: i18n.gettext('Recomendamos usar el color “White” si el fondo de tu tienda es oscuro.'),
        messageType: 'info',
        hierarchy: 'quiet',
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandYellowBrandFields,
          },
          {
            inputId: 'theme',
            expectedValue: ['default'],
          },
          {
            inputId: 'valuePropColorYellowBrand',
            expectedValue: ['white'],
          },
        ],
      },
      {
        id: 'valuePropColorMessageDark',
        type: 'message',
        children: i18n.gettext('Recomendamos usar el tema “Dark” si el fondo de tu tienda es claro.'),
        messageType: 'info',
        hierarchy: 'quiet',
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandYellowBrandFields,
          },
          {
            inputId: 'theme',
            expectedValue: ['dark'],
          },
        ],
      },

      // --------------------------------------------------------
      {
        id: 'buttonStyleTitle',
        type: 'title',
        title: i18n.gettext('Estilo del botón'),
        width: 'full',
      },
      {
        id: 'buttonHeight',
        type: 'slider',
        label: i18n.gettext('Alto'),
        defaultValue: 48,
        trackingLabel: 'BUTTON_HEIGHT',
        minValue: 48,
        maxValue: 124,
        width: 'full',
      },
      {
        id: 'buttonWidth',
        type: 'slider',
        label: i18n.pgettext('pymes', 'Largo'),
        tooltipContent: i18n.gettext('El ajuste de ancho es solo una demostración. Cuando lo agregues a tu tienda, el ancho del botón será del 100% del container en el que se inserte.'),
        defaultValue: 270,
        trackingLabel: 'BUTTON_WIDTH',
        minValue: 270,
        maxValue: 540,
        width: 'full',
      },
      {
        id: 'borderRadius',
        type: 'slider',
        label: i18n.gettext('Borde'),
        defaultValue: 6,
        trackingLabel: 'BORDER_RADIUS',
        minValue: 0,
        maxValue: 124,
        width: 'full',
      },
      {
        id: 'verticalPaddingBlueBrand',
        type: 'slider',
        label: i18n.gettext('Padding vertical'),
        defaultValue: 16,
        trackingLabel: 'VERTICAL_PADDING',
        minValue: 16,
        maxValue: 124,
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandBlueBrandFields,
          },
        ],
      },
      {
        id: 'verticalPaddingYellowBrand',
        type: 'slider',
        label: i18n.gettext('Padding vertical'),
        defaultValue: 8,
        trackingLabel: 'VERTICAL_PADDING',
        minValue: 8,
        maxValue: 124,
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: showBrandYellowBrandFields,
          },
        ],
      },
      {
        id: 'horizontalPadding',
        type: 'slider',
        label: i18n.gettext('Padding horizontal'),
        defaultValue: 0,
        trackingLabel: 'HORIZONTAL_PADDING',
        minValue: 0,
        maxValue: 124,
        width: 'full',
      },
      {
        id: 'buttonStyleTitle',
        type: 'title',
        title: i18n.gettext('Estilo del checkout'),
        label: i18n.gettext('Estas customizaciones solo se reflejan en el código.'),
        width: 'full',
      },
      {
        id: 'redirectMode',
        type: 'dropdown',
        label: i18n.gettext('Modo de apertura del checkout'),
        placeholder: i18n.gettext('Modo de apertura del checkout'),
        trackingLabel: 'REDIRECT_MODE',
        defaultValue: 'blank',
        items: [
          { value: 'blank', primary: i18n.gettext('En otra página') },
          { value: 'self', primary: i18n.gettext('En la misma página') },
        ],
        width: 'full',
      },
      {
        id: 'colorProps',
        type: 'twoColumns',
        items: [
          {
            id: 'headerColor',
            type: 'textfield',
            width: 'full',
            prefix: '#',
            label: i18n.gettext('Color del header'),
            defaultValue: '4287F5',
          },
          {
            id: 'elementsColor',
            type: 'textfield',
            width: 'full',
            prefix: '#',
            label: i18n.gettext('Color de los elementos'),
            defaultValue: '4287F5',
          },
        ],
      },
      {
        id: 'brand',
        type: 'dropdown',
        label: i18n.gettext('Brand'),
        placeholder: i18n.gettext('Brand'),
        trackingLabel: 'BRAND',
        defaultValue: 'cyan-light',
        items: [
          { value: 'cyan-light', primary: i18n.gettext('Pagar con Mercado Pago') },
          { value: 'yellowblue-light', primary: i18n.gettext('Comprar con Mercado Pago') },
        ],
        width: 'full',
        conditionalRender: [
          {
            inputId: 'publicKey',
            expectedValue: false,
          },
        ],
      },
    ],
  };
}

function getProps(i18n, lang, brand) {
  return componentProps(i18n, lang, brand);
}

module.exports = { getProps };
